

$(document).ready(function () {
    if ($(window).width() < 768) {
        $('.review-section-images').slick({
                centerMode: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            autoplay: true,
    autoplaySpeed: 1,
    speed: 6000,
    cssEase: 'linear',
    waitForAnimate: false,
    pauseOnFocus: false, 
    pauseOnHover: false
        });
    }
    $('.text-reviews-slider').slick({
            infinite: true,
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: false,
            arrows: true,
            prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0974/9905/4425/files/Left.png?v=1772695954" class="slick-prev custom-prev" width="40" height="40">',
            nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0974/9905/4425/files/Right.png?v=1772695954" class="slick-next custom-next" width="40" height="40">',
             responsive: [
    
    {
      breakpoint: 560,
      settings: {
        slidesToShow: 1.1 ,
      dots: true,
            arrows: false,     }
    }
  ]
        });

         $('.media-review-slider').slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            prevArrow: '<img src="https://cdn.shopify.com/s/files/1/0974/9905/4425/files/Left.png?v=1772695954" class="slick-prev custom-prev" width="40" height="40">',
            nextArrow: '<img src="https://cdn.shopify.com/s/files/1/0974/9905/4425/files/Right.png?v=1772695954" class="slick-next custom-next" width="40" height="40">',
             responsive: [
    
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1  ,
      arrows: true    }
    }
  ]
        });



$('.media-review-slider').on('afterChange', function(event, slick, currentSlide){

    slick.$slides.each(function(index){

        if(index !== currentSlide){

            $(this).find('video').each(function(){
                this.pause();

                var id = $(this).attr('id');

                $('.video-icon.pause[data-target="'+id+'"]').hide();
                $('.video-icon.play[data-target="'+id+'"]').show();
            });

        }

    });

});

    $('.product-media-slider').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: false,
            arrows: false,
            asNavFor: '.product-thumbnail-slider'
        });
        $('.product-thumbnail-slider').slick({
        slidesToShow: 6,
  slidesToScroll: 1,
  focusOnSelect: true,
        vertical: true,
        verticalSwiping: true,
        arrows: false,
        asNavFor: '.product-media-slider',
        responsive: [
    
    {
      breakpoint: 768,
      settings: {
        vertical: false,
        verticalSwiping: false,
        slidesToShow: 6,
        slidesToScroll: 1
      }
    }
  ]
        });

        $('.click-scroll').on('click', function(){
  var target = $(this).data('target');

  $('html, body').animate({
    scrollTop: $('#' + target).offset().top + 100
  }, 600);
});




$(document).on('click', '.video-icon.play', function () {
    var target = $(this).data('target');
    var video = $('#' + target).get(0);

    if (video) {
        video.play();
    }

    $(this).hide();
    $('.video-icon.pause[data-target="'+target+'"]').show();
});

$(document).on('click', '.video-icon.play', function () {
    var target = $(this).data('target');
    var video = $('#' + target).get(0);

    // Pause all videos
    $('video').each(function () {
        this.pause();
    });

    // Reset all icons
    $('.video-icon.pause').hide();
    $('.video-icon.play').show();

    // Play selected video
    if (video) {
        video.play();
    }

    // Toggle icons for current video
    $(this).hide();
    $('.video-icon.pause[data-target="'+target+'"]').show();
});


$(document).on('click', '.video-icon.pause', function () {
    var target = $(this).data('target');
    var video = $('#' + target).get(0);

    if (video) {
        video.pause();
    }

    $(this).hide();
    $('.video-icon.play[data-target="'+target+'"]').show();
});

var imgHeight = $('.review-media img.review-media-img').height();
    $('.review-media video').height(imgHeight);
})
